//インスタグラム取得
(function ($) {
    $.ajax({  // jQueryのajaxでjsonデータを取得
      type: 'GET',
      url: 'https://graph.facebook.com/v18.0/17841448670241510?access_token=EAAJgloPDTeEBOxwcDj0WbZCWZAuZCMCbKBVe9vv2uP30jitTKgBNhZBmfXczZAJPqvmOSAxXzsUsd5Pj7pZBQRrorcDZCKi0Kgh4AKsIDZAUZADFqjk4NzZAFurw1PZBtdG4Bk3tK7Mo6kwEpMifClEdIUihftqtqOMy8GDhTnth0ZAjmMjwY5OQtvvyuFSU1EsJhroZD&fields=name,media%7Bcaption,like_count,media_url,permalink,timestamp,username%7D',
      dataType: 'json',
      success: function (json) {
        var insta = json.media.data;
        for (var i = 0; i < 12; i++) {
          let url = insta[i].media_url; // 動画ソースのURLを取得
          let href = insta[i].permalink; // リンク先URLを取得
          let caption = insta[i].caption; //　投稿のキャプションを取得
          let like = insta[i].like_count; //　いいね！数の取得
          $('.section-instagram .image__items').append(`
                    <div class="item">
                    <a href="${href}">
                    <figure class="image__wrapper">
                        <img src="${url}" alt="${caption}">
                    </figure>
                    </a>
                </div>
              `);
  
        }
      }
    });
  })(jQuery);